import { useFormik } from "formik";
import { SMART_NAME, SMART_TYPE } from "libs/constant/smartForm";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultChildren,
  defaultCompanies,
  defaultJobTable,
  defaultSpouse,
  defaultStakeholders,
  getDefaultRow,
  getPartFormId,
  getValueByPartForm,
  mapChildren,
  mapCompanies,
  mapJobTable,
  mapSpouse,
  mapStakeholders,
} from "libs/utils/form";
import { formatDate } from "libs/utils/format";
import { get, pick } from "lodash-es";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPersonal,
  addPersonalSlice,
  selectAddPersonal,
} from "redux/modules/addPersonalSlice";
import { getMasterData } from "redux/modules/masterSlice";
import { selectPassportState } from "redux/modules/passportSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  addExtension,
  addExtensionSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddExtension,
  selectCurrentConditionType,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormExtension,
  selectSmartFormFieldConfig,
  selectSmartService,
} from "redux/modules/visaForm";
import * as yup from "yup";

const getFieldListByPartForm = (partFromName) => {
  switch (partFromName) {
    case "Part A":
      return [
        "Marittal",
        "AddressInThai",
        "PhoneNumber",
        "Email",
        "Spouse",
        "Children",
        "Smart",
        "JobTable",
        // "JobPosition",
        // "JobSubPosition",
        // "JobDescription",
        "ValidUntil",
        "ContactPersonInThai",
        "ContactRelationship",
        "ContactEmail",
        "ContactMobile",
        "SubDistrict",
        "District",
        "Province",
        "Zipcode",
      ];
    case "Part B":
      return [
        "activitiesId",
        "activitiesIdSub",
        "startupSecId",
        "startupStageId",
      ];
    case "Part C":
      return [
        "CompanyRegisterNumber",
        "CompanyRegisterDate",
        "CompanyName",
        "CompanyAddress",
        "OfficeNumber",
        "CompanyWebSite",
        "ProductService",
        "MajorService",
        "SaleRevenune",
        "ProcessDiagram",
        "Explanation",
        "technologyCore",
        "technologyCoreExplain",
        "technologyEmployment",
        "technologyEmploymentExplain",
        "ContractTermType",
        "ContractYear",
        "ContractMonth",
        "ContractPeriodFrom",
        "ContractPeriodTo",
        "ContractOther",
        "AverageIncomeBaht",
        "SalaryBaht",
        "OrtherIncome",
        "applicants",
        "specift",
      ];
    case "Part F":
      return [
        "DirectInvestmentTechnology",
        "Investmentthrough",
        "DirectInvestmentStartup",
        "Companies",
        "Totalvalue",
      ];
    case "From A":
      return [
        "CompanyRegisterNumber",
        "CompanyName",
        "CompanyAddress",
        "OfficeNumber",
        "CompanyWebSite",
        "ProductService",
        "MajorService",
        "SaleRevenune",
        "activitiesId",
        "activitiesIdSub",
        "Explanation",
        "ProcessDiagram",
        "assignmentId",
        "AmountofShare",
        "ValuePerShare",
        "SharesOwned",
        "technologyCore",
        "technologyCoreExplain",
        "technologyEmployment",
        "technologyEmploymentExplain",
      ];
    case "Part G":
      return [
        "accompanyFistName",
        "accompanyMiddleName",
        "accompanyLastname",
        "accompanyTypeSmartVisa",
        "accompanyRelationship",
        "EmployerInThai",
        "JobPosition",
        "WorkAddress",
        "PhoneNumber",
        "Email",
        "JobDescription",
        "NameOfReference",
        "Position",
        "EmailReference",
        "MobilePhone",
      ];
    case "Part D":
      return [
        "OrganiztionName",
        "OrganiztionAddress",
        "OrganiztionPhone",
        "OrganiztionType",
        "RefernceName",
        "ReferncePosition",
        "RefernceEmail",
        "RefernceMobile",
      ];
    case "Part E":
      return [
        "Companyprogress",
        "CompanyprogressDetail",
        "Companyprogress2",
        "CompanyprogressDetail2",
        "Companyprogress3",
        "CompanyprogressDetail3",
        "stakeholders",
        "ProductDev",
        "CustomerTest",
        "CompanyStr",
        "TechnicalDev",
        "AgenciesYou",
        "HumanRes",
        "UpdatedBus",
        "UpdatedFin",
        "UpdatedMark",
        "Difficulties",
      ];
    default:
      return "";
  }
};

const getDefaultRowValue = (fieldValue, key) => {
  const mapRowDefaultValue = (mapFn, defaultVal) => {
    const rows = getDefaultRow(fieldValue, `${key}.value`, defaultVal).map(
      mapFn
    );
    return rows && rows.length ? rows : [mapFn(defaultVal)];
  };

  switch (key) {
    case "Children": {
      return mapRowDefaultValue(mapChildren, defaultChildren);
    }
    case "Spouse": {
      return mapRowDefaultValue(mapSpouse, defaultSpouse);
    }
    case "Companies": {
      return mapRowDefaultValue(mapCompanies, defaultCompanies);
    }
    case "stakeholders": {
      return mapRowDefaultValue(mapStakeholders, defaultStakeholders);
    }
    case "JobTable": {
      return mapRowDefaultValue(mapJobTable, defaultJobTable);
    }
    default:
      return "";
  }
};

const getDefaultValue = (fieldValue, key, defaultValue = "") => {
  const fieldRow = getDefaultRowValue(fieldValue, key);

  if (fieldRow) return fieldRow;

  return get(fieldValue, `${key}.value`, defaultValue) || defaultValue;
};

const getInitialValues = (partFromName, fieldValue) => {
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  return fieldListByPartForm.reduce((fields, fieldName) => {
    if (fieldName === "ProcessDiagram") {
      const defaultProcessDiagram = getDefaultValue(fieldValue, fieldName);
      return {
        ...fields,
        [fieldName]: {
          ext: defaultProcessDiagram.ext,
          FileID: defaultProcessDiagram.fileID,
          filename: defaultProcessDiagram.fileID,
          processfileID: defaultProcessDiagram.fileID,
          Status: defaultProcessDiagram.status || true,
        },
      };
    }

    return {
      ...fields,
      [fieldName]: getDefaultValue(fieldValue, fieldName),
    };
  }, {});
};

const prepareRequestFormData = (values, defaultType, partfromId, valueKey) => {
  const documentFields = Object.keys(valueKey ? get(values, valueKey) : values);
  const getFieldListConfig = defaultType
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => documentFields.includes(field.smartName));

  const getValue = (field) => {
    const sendNullIsEmptyBy = (detectField) => {
      const rawValue = get(
        values,
        `${valueKey ? `${valueKey}.` : ""}${field.smartName}`,
        null
      );

      if (!detectField) return rawValue || null;
      const value = (rawValue || []).filter((v) => !!v[detectField]);
      return value || null;
    };

    switch (field.smartName) {
      case "Spouse": {
        return sendNullIsEmptyBy("SpouseName");
      }
      case "Children": {
        return sendNullIsEmptyBy("ChildrenName");
      }
      case "Companies": {
        return sendNullIsEmptyBy("CompanyName");
      }
      case "stakeholders": {
        return sendNullIsEmptyBy("Name");
      }
      case "JobTable": {
        return sendNullIsEmptyBy("jobTitle");
      }
      case "ProcessDiagram": {
        const FileID = sendNullIsEmptyBy("")?.FileID;
        if (!FileID) return null;
        return sendNullIsEmptyBy("");
      }
      default:
        return sendNullIsEmptyBy("");
    }
  };

  const getSmartId = (field) => get(values, `${field.smartName}.smartId`, null);

  const prepareData = {
    draftId: null,
    smartserviceId: null,
    personalId: null,
    smartserviceReferId: null,
    draftIdRef: null,
    survey: null,
    visaissuance: null,
    detail: [
      ...getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    ],
  };

  return prepareData;
};

export function useExtendsionFormPartA() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const passportState = useSelector(selectPassportState);
  const personalDetail = useSelector(selectPersonalDetail);
  const addPersonalState = useSelector(selectAddPersonal);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartFormExtensionState = useSelector(selectSmartFormExtension);
  const conditionType = useSelector(selectCurrentConditionType);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const ocrFirstName = get(passportState, "detail.firstName", "");
  const ocrLastName = get(passportState, "detail.lastName", "");

  const draftIdRef = get(smartform, "draftIdRef", null);
  const smartserviceName =
    smartFormExtensionState?.data?.smartserviceName ?? "";

  const personal = pick(get(smartform, "personal", {}), [
    "personalID",
    "firstname",
    "middleName",
    "lastName",
    "nationalityID",
    "birthDate",
    "email",
    "placeOfBirth",
    "gender",
    "passportNumber",
    "dateofIssue",
    "validuntil",
    "visatypeID",
  ]);

  const partFromName = "Part A";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        JobPositionConfig: true,
        CountryConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addPersonalState.isLoading) {
      if (addPersonalState.isSuccess) {
        dispatch(addPersonalSlice.actions.clearAsyncState());
      } else if (addPersonalState.isFailure) {
        hideLoading();
        alert(addPersonalState.error?.message);
        dispatch(addPersonalSlice.actions.clearAsyncState());
      }
    }
  }, [
    addPersonalState.error?.message,
    addPersonalState.isFailure,
    addPersonalState.isLoading,
    addPersonalState.isSuccess,
    dispatch,
    hideLoading,
  ]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_B));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId,
      "document"
    );

    const detail = get(smartform, "detail", []);
    const getSmartId = (field) =>
      get(smartform, `${field.smartName}.smartId`, null);
    const prepareData = {
      ...prepareRequestData,
      ...(!draftIdRef
        ? {
            draftId: null,
            draftIdRef: draftId,
            smartserviceId: "ea67ab08-5953-4453-0830-28ed243a8d38",
            smartserviceReferId: smartServiceId,
            personalId: personalId,
          }
        : {
            draftId: smartform.draftId,
            draftIdRef: smartform.draftIdRef,
            smartserviceId: smartform.smartserviceId,
            smartserviceReferId: smartform.smartserviceReferId,
            personalId: personalId,
          }),
      detail: [
        ...(!draftIdRef
          ? detail
              .filter(
                (v) =>
                  !prepareRequestData.detail.some(
                    (c) => c.configsmartId === v.configsmartId
                  )
              )
              .map((c) => {
                if (
                  c.smartName === "ConditionType" &&
                  smartserviceName === SMART_TYPE.SMART_S
                ) {
                  return {
                    ...c,
                    value: conditionType || null,
                    smartId: getSmartId(c),
                  };
                }
                return { ...c, smartId: getSmartId(c) };
              })
          : []),
        ...prepareRequestData.detail,
      ],
    };

    await dispatch(
      addPersonal({
        ...values.personal,
        visatypeID: null,
      })
    );

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        personalID: get(personal, "personalID", ""),
        fistName: get(personal, "firstname", "") || ocrFirstName,
        middleName: get(personal, "middleName", "") || "",
        lastName: get(personal, "lastName", "") || ocrLastName,
        nationalityID: get(personal, "nationalityID", "") || "",
        birthDate: formatDate(get(personal, "birthDate", "") || ""),
        email: get(personal, "email", "") || "",
        placeOfBirth: get(personal, "placeOfBirth", "") || "",
        gender: get(personal, "gender", "M") || "M",
        passportNumber: get(personal, "passportNumber", "") || "",
        dateofIssue: formatDate(get(personal, "dateofIssue", "") || ""),
        validuntil: formatDate(get(personal, "validuntil", "") || ""),
        visatypeID: null,
      },
      document: getInitialValues(partFromName, fieldValue),
    },
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormPartB() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");
  const isSmartS = SMART_NAME[smartserviceName] === SMART_TYPE.SMART_S;

  const partFromName = "Part B";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        startupSectorsConfig: true,
        ActivitiesConfig: true,
        startupStageConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          console.log("smartService => ", smartService);
          console.log("currentSmart => ", currentSmart);
          console.log("smartserviceName => ", smartserviceName);
          console.log("smartserviceName => ", SMART_NAME[smartserviceName]);
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_T:
              dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
              break;
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_I:
              dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
              break;
            case SMART_TYPE.SMART_O:
              dispatch(setSmartFormStep(SMART_T_STEP.PART_G));
              break;
            case SMART_TYPE.SMART_S: {
              const smartformDetail = get(smartform, "detail", []).reduce(
                (p, c) => ({ ...p, [c.smartName]: c }),
                {}
              );
              const conditionType = get(
                smartformDetail,
                "ConditionType.value",
                ""
              );
              console.log("conditionType => ", conditionType);
              if (conditionType === "6MA" || conditionType === "6MB") {
                dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
              } else {
                dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
              }
              break;
            }
            default:
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    currentSmart,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartService,
    smartServiceId,
    smartform,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
    isSmartS,
  };
}

export function useExtendsionFormPartC() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "Part C";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
        applicantConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_I:
              dispatch(setSmartFormStep(SMART_T_STEP.PART_F));
              break;
            case SMART_TYPE.SMART_T:
              dispatch(setSmartFormStep(SMART_T_STEP.PART_D));
              break;
            case SMART_TYPE.SMART_E:
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              break;
            case SMART_TYPE.SMART_S: {
              const smartformDetail = get(smartform, "detail", []).reduce(
                (p, c) => ({ ...p, [c.smartName]: c }),
                {}
              );
              const conditionType = get(
                smartformDetail,
                "ConditionType.value",
                ""
              );
              if (conditionType === "1YA" || conditionType === "1YB") {
                dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
              } else {
                dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
              }
              break;
            }
            case SMART_TYPE.SMART_O:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormPartE() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "Part E";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  console.log("prepareData => fieldValue ", fieldValue);

  useEffect(() => {
    dispatch(
      getMasterData({
        CompanyprogressConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_S: {
              dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
              break;
            }
            case SMART_TYPE.SMART_I:
            case SMART_TYPE.SMART_T:
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_O:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    console.log("prepareData => ", prepareData);

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormPartF() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "Part F";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
        applicantConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_I:
              dispatch(setSmartFormStep(SMART_T_STEP.FROM_A));
              break;
            case SMART_TYPE.SMART_T:
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_O:
            case SMART_TYPE.SMART_S:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const mapDefaultStringBoolean = (values) => {
    const fieldStringBooleanList = [
      "DirectInvestmentTechnology",
      "Investmentthrough",
      "DirectInvestmentStartup",
    ];
    const convertBoolValues = Object.keys(values)
      .filter((key) => fieldStringBooleanList.includes(key))
      .reduce(
        (p, c) => ({
          ...p,
          [c]: values[c] === "True",
        }),
        {}
      );
    return { ...values, ...convertBoolValues };
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: mapDefaultStringBoolean(
      getInitialValues(partFromName, fieldValue)
    ),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormFormA() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "From A";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        ActivitiesConfig: true,
        AssignmentConfig: true,
        technologyCoreConfig: true,
        technologyEmploymentConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_I:
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              break;
            case SMART_TYPE.SMART_T:
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_O:
            case SMART_TYPE.SMART_S:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormPartG() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "Part G";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        SmartService: true,
        RelationshipConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_O:
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              break;
            case SMART_TYPE.SMART_I:
            case SMART_TYPE.SMART_T:
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_S:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}

export function useExtendsionFormPartD() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const smartform = useSelector(selectCurrentSmartForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const addExtensionState = useSelector(selectAddExtension);
  const smartService = useSelector(selectSmartService);

  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const personalId = get(personalDetail, "personalID", "");
  const smartserviceReferId = get(smartform, "smartserviceReferId");
  const currentSmart = get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceReferId
  );
  const smartserviceName = get(currentSmart, "smartserviceName", "");

  const partFromName = "Part D";
  const fieldListByPartForm = getFieldListByPartForm(partFromName);
  const partfromId = getPartFormId(defaultType, partFromName);
  const fieldValue = getValueByPartForm(
    smartform,
    fieldListByPartForm,
    partfromId
  );

  useEffect(() => {
    dispatch(
      getMasterData({
        OrganiztionTypeConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addExtensionState.isLoading) {
      if (addExtensionState.isSuccess) {
        hideLoading();
        dispatch(addExtensionSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          switch (SMART_NAME[smartserviceName]) {
            case SMART_TYPE.SMART_T:
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              break;
            case SMART_TYPE.SMART_O:
            case SMART_TYPE.SMART_I:
            case SMART_TYPE.SMART_E:
            case SMART_TYPE.SMART_S:
            default:
              dispatch(setSmartFormStep(SMART_T_STEP.NONE));
              dispatch(setHomeTab(HOME_TAB.INFORMATION));
              break;
          }
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addExtensionState.isFailure) {
        hideLoading();
        alert(addExtensionState.error?.message);
        dispatch(addExtensionSlice.actions.clearAsyncState());
      }
    }
  }, [
    addExtensionState.error?.message,
    addExtensionState.isFailure,
    addExtensionState.isLoading,
    addExtensionState.isSuccess,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
    smartserviceName,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const prepareRequestData = prepareRequestFormData(
      values,
      defaultType,
      partfromId
    );

    const prepareData = {
      ...prepareRequestData,
      draftId: smartform.draftId,
      draftIdRef: smartform.draftIdRef,
      smartserviceId: smartform.smartserviceId,
      smartserviceReferId: smartform.smartserviceReferId,
      personalId: personalId,
    };

    await dispatch(addExtension(prepareData));
  };

  const onSaveDraft = () => {
    setSaveDraft(true);
    callAPISubmit(formik.values);
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(partFromName, fieldValue),
    validationSchema,
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return {
    formik,
    onSaveDraft,
  };
}
